// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"25a7c8aa","127":"eb8df7fc","508":"d700e4f5","620":"812d71ff","837":"abe4ad68","886":"e99b4b5e"}[chunkId] + ".js";
};